export default {
  title: {
    en: 'Resubscribe for 50% off next month',
  },
  text: {
    en: `
    We miss you and would love to have you back, so we’ll take 50% OFF your
    next scent when you reactivate your subscription today.
  `,
  },
  btnJoinTheClub: {
    en: 'JOIN THE CLUB: NEXT MONTH 50% OFF',
  },
  btnNoThanks: {
    en: 'No Thanks',
  },
  paymentPageTitle: {
    en: 'Reactivate with 50% discount',
  },
}
